export const setModalOpenState = 'setModalOpenState';
export const closeAllModals = 'closeAllModals';
export const openModal = 'openModal';
export const closeModal = 'closeModal';
